import { render, staticRenderFns } from "./EnergySankey.vue?vue&type=template&id=50991bb8&scoped=true"
import script from "./EnergySankey.vue?vue&type=script&lang=js"
export * from "./EnergySankey.vue?vue&type=script&lang=js"
import style0 from "./EnergySankey.vue?vue&type=style&index=0&id=50991bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50991bb8",
  null
  
)

export default component.exports